export default "__VITE_ASSET__63d95460__"